import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

// User
const UserResetPass = () => import('@/views/users/UserResetPass')
const UserAdd = () => import('@/views/users/UserAdd')
const UserUpdate = () => import('@/views/users/UserUpdate')
const UsersList = () => import('@/views/users/UsersList')
const UserProfile = () => import('@/views/users/UserProfile')
const UserLogin = () => import('@/views/users/UserLogin')
const UserRegister = () => import('@/views/users/UserRegister')
const UserCompleteReg = () => import('@/views/users/UserCompleteReg')

// Category
const CategoryList = () => import('@/views/category/CategoryList')
const CategoryAdd = () => import('@/views/category/CategoryAdd')
const CategoryUpdate = () => import('@/views/category/CategoryUpdate')

// Slide
const SlideList = () => import('@/views/sliders/SlideList')
const SlideAdd = () => import('@/views/sliders/SlideAdd')
const SlideUpdate = () => import('@/views/sliders/SlideUpdate')

// Specifications
const SpecificationList = () => import('@/views/specifications/SpecificationList')
const SpecificationAdd = () => import('@/views/specifications/SpecificationAdd')
const SpecificationUpdate = () => import('@/views/specifications/SpecificationUpdate')

// Views - Pages
const Page403 = () => import('@/views/pages/Page403')
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')

// Thread
const ThreadList = () => import('@/views/thread/ThreadList')

// Logs
const AccessPage = () => import('@/views/logs/AccessPage')

// Policy
const PolicyList = () => import('@/views/policy/PolicyList')
const PolicyAdd = () => import('@/views/policy/PolicyAdd')
const PolicyUpdate = () => import('@/views/policy/PolicyUpdate')

//Product
const ProductList = () => import('@/views/product/ProductList') 
const ProductAdd = () => import('@/views/product/ProductAdd') 
const ProductUpdate = () => import('@/views/product/ProductUpdate')
const ProductSaleList = () => import('@/views/product/ProductSaleList')

//Sale Program
const SaleProgramList = () => import('@/views/sale_program/SaleProgramList')
const SaleProgramAdd = () => import('@/views/sale_program/SaleProgramAdd')
const SaleProgramUpdate = () => import('@/views/sale_program/SaleProgramUpdate')


Vue.use(Router)
let router = new Router({
  // mode: 'hash', // https://router.vuejs.org/api/#mode
  base:  process.env.NODE_ENV === 'development' ? '/' : '/',
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({y: 0}),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: TheContainer,
      children: [
        {
          path: '/dashboard.html',
          name: 'Dashboard',
          component: Dashboard,
          meta: {
            requiresAuth: true,
          }
        },
        {
          path: '/user-management/my-profile',
          name: 'Hồ sơ cá nhân',
          component: UserProfile,
          meta: {
            requiresAuth: true,
          }
        },
        // {
        //   path: '/user-management',
        //   redirect: '/user-management/managed-users',
        //   name: 'Quản lý tài khoản',
        //   meta: {
        //     requiresAuth: true,
        //   },
        //   component: {
        //     render(c) {
        //       return c('router-view')
        //     }
        //   },
        //   children: [
        //     {
        //       path: 'my-profile',
        //       name: 'Hồ sơ cá nhân',
        //       component: UserProfile,
        //       meta: {
        //         requiresAuth: true,
        //       }
        //     },
        //     {
        //       path: 'new',
        //       name: 'Thêm mới tài khoản',
        //       component: UserAdd,
        //       meta: {
        //         requiresAuth: true,
        //         isAdmin: true,
        //       }
        //     },
        //     {
        //       path: 'managed-users',
        //       name: 'Danh sách tài khoản',
        //       component: UsersList,
        //       meta: {
        //         requiresAuth: true,
        //         isAdmin: true,
        //       }
        //     },
        //     // {
        //     //   path: 'create-account.html',
        //     //   name: 'Thêm mới tài khoản',
        //     //   component: UserAdd,
        //     //   meta: {
        //     //     requiresAuth: true,
        //     //     isAdmin: true,
        //     //   }
        //     // },
        //     {
        //       path: 'managed-users/:id',
        //       name: 'Cập nhật tài khoản',
        //       component: UserUpdate,
        //       meta: {
        //         requiresAuth: true,
        //         isAdmin: true,
        //       }
        //     },
        //   ]
        // },
        {
          path: '/category-management',
          redirect: '/category-management/managed-categories',
          name: 'Quản lý danh mục',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'managed-categories',
              name: 'Danh sách danh mục',
              component: CategoryList,
              meta: {
                requiresAuth: true,
                isAdmin: true,
              }
            },
            {
              path: 'add',
              name: 'Thêm mới danh mục',
              component: CategoryAdd,
              meta: {
                requiresAuth: true,
                isAdmin: true,
              }
            },
            {
              path: 'managed-category/:id',
              name: 'Cập nhật danh mục',
              component: CategoryUpdate,
              meta: {
                requiresAuth: true,
                isAdmin: true,
              }
            },
          ]
        },
        {
          path: '/products-management',
          redirect: '/products-management/managed-product',
          name: 'Quản lý sản phẩm',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'managed-product',
              name: 'Danh sách sản phẩm',
              component: ProductList,
              meta: {
                requiresAuth: true,
                isAdmin: true,
              }
            },
            {
              path: 'managed-product-sale',
              name: 'Danh sách sản phẩm khuyến mại',
              component: ProductSaleList,
              meta: {
                requiresAuth: true,
                isAdmin: true,
              }
            },
            {
              path: 'add',
              name: 'Thêm mới sản phẩm',
              component: ProductAdd,
              meta: {
                requiresAuth: true,
                isAdmin: true,
              }
            },
            {
              path: 'update/:id',
              name: 'Cập nhật sản phẩm',
              component: ProductUpdate,
              meta: {
                requiresAuth: true,
                isAdmin: true,
              }
            },
            {
              path: 'managed-specification',
              name: 'Danh sách thông số kỹ thuật',
              component: SpecificationList,
              meta: {
                requiresAuth: true,
                isAdmin: true,
              }
            },
            {
              path: 'managed-specification/add',
              name: 'Thêm mới thông số ký thuật',
              component: SpecificationAdd,
              meta: {
                requiresAuth: true,
                isAdmin: true,
              }
            },
            {
              path: 'managed-specification/:id',
              name: 'Cập nhật thông số kỹ thuật',
              component: SpecificationUpdate,
              meta: {
                requiresAuth: true,
                isAdmin: true,
              }
            }
          ]
        },
        {
          path: '/policy-management',
          redirect: '/policy-management/managed-policies',
          name: 'Quản lý chính sách',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'managed-policies',
              name: 'Danh sách chính sách',
              component: PolicyList,
              meta: {
                requiresAuth: true,
                isAdmin: true,
              }
            },
            {
              path: 'add',
              name: 'Thêm mới chính sách',
              component: PolicyAdd,
              meta: {
                requiresAuth: true,
                isAdmin: true,
              }
            },
            {
              path: 'update/:id',
              name: 'Cập nhật chính sách',
              component: PolicyUpdate,
              meta: {
                requiresAuth: true,
                isAdmin: true,
              }
            }
          ]
        },
        {
          path: '/sale-program-management',
          redirect: '/sale-program-management/managed-sale-program',
          name: 'Quản lý chương trình khuyến mại',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'managed-sale-program',
              name: 'Danh sách chương trình khuyến mại',
              component: SaleProgramList,
              meta: {
                requiresAuth: true,
                isAdmin: true,
              }
            },
            {
              path: 'add',
              name: 'Thêm mới chương trình khuyến mại',
              component: SaleProgramAdd,
              meta: {
                requiresAuth: true,
                isAdmin: true,
              }
            },
            {
              path: 'update/:id',
              name: 'Cập nhật chương trình khuyến mại',
              component: SaleProgramUpdate,
              meta: {
                requiresAuth: true,
                isAdmin: true,
              }
            },
          ]
        },
        {
          path: '/slider-management',
          redirect: '/slider-management/managed-sliders',
          name: 'Quản lý slider',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'managed-sliders',
              name: 'Danh sách Slider',
              component: SlideList,
              meta: {
                requiresAuth: true,
                isAdmin: true,
              }
            },
            {
              path: 'add',
              name: 'Thêm mới Slider',
              component: SlideAdd,
              meta: {
                requiresAuth: true,
                isAdmin: true,
              }
            },
            {
              path: 'managed-slider/:id',
              name: 'Cập nhật Slider',
              component: SlideUpdate,
              meta: {
                requiresAuth: true,
                isAdmin: true,
              }
            },
          ]
        },
        {
          path: '/system-management',
          redirect: '/system-management/managed-threads',
          name: 'Hệ thống',
          meta: {
            requiresAuth: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'managed-threads',
              name: 'DS tiến trình',
              component: ThreadList
            }
          ]
        },
        {
          path: '/statistics-management',
          redirect: '/statistics-management/managed-access-logs',
          name: 'Thống kê',
          meta: {
            requiresAuth: true,
            isAdmin: true,
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'managed-access-logs',
              name: 'Lịch sử truy cập',
              component: AccessPage
            }
          ]
        },
      ]
    },
    {
      path: '/login.html',
      name: 'UserLogin',
      component: UserLogin,
    },
    {
      path: '/register.html',
      name: 'UserRegister',
      component: UserRegister,
    },
    {
      path: '/complete-reg.html',
      name: 'complete-reg',
      component: UserCompleteReg,
    },
    {
      path: '/errors',
      redirect: '/errors/404',
      name: 'errors',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '403',
          name: 'page403',
          component: Page403
        },
        {
          path: '404',
          name: 'page404',
          component: Page404
        },
        {
          path: '500',
          name: 'page500',
          component: Page500
        }
      ]
    },
    {
      path: '/user',
      name: 'user',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: 'reset-password.html',
          name: 'UserResetPass',
          component: UserResetPass
        }
      ]
    },
    {
      path: '*',
      name: '404',
      component: Page404,
      meta: {
        requiresAuth: true,
      }
    },
  ]
})

export default router
